export default __webpack_public_path__ + "static/montserrat-v15-latin-900italic-efcaa0f6a82ee0640b83a0916e6e8d68.woff";